import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPaginatedResults, IPaginatedResultsDictionary } from "../common/pagination/model";
import { ISalesforceCase, ISalesforceCaseContactFilterMetadata, ISalesforceCaseContactOption } from "./model";

interface ISalesforceMetadataState {
    statuses: Record<string, string> | null;
    contacts: ISalesforceCaseContactOption[] | null;
    defaultContactId: string | null;
    machines: string[] | null;
}

declare global {
    interface IStoreState {
        salesforceResults: IPaginatedResultsDictionary<ISalesforceCase>;
        salesforceMetadata: ISalesforceMetadataState;
    }
}

const salesforceResults = createSlice({
    name: "salesforceResults",
    initialState: {
        currentPage: 1,
        totalPages: 0,
        totalRecords: 0,
        pageSize: 10,
        items: null,
    } as IPaginatedResultsDictionary<ISalesforceCase>,
    reducers: {
        setResults: (state, { payload }: PayloadAction<IPaginatedResults<ISalesforceCase>>) => {
            if (!state.items || state.totalRecords != payload.totalRecords) state.items = {};
            state.items[payload.currentPage] = payload.items;
            state.totalPages = payload.totalPages;
            state.totalRecords = payload.totalRecords;
            state.currentPage = payload.currentPage;
        },
    },
});

const salesforceMetadata = createSlice({
    name: "salesforceMetadata",
    initialState: {
        statuses: null,
        contacts: null,
        defaultContactId: null,
        machines: null,
    } as ISalesforceMetadataState,
    reducers: {
        setStatuses: (state, { payload }: PayloadAction<Record<string, string>>) => {
            state.statuses = payload;
        },
        setContactFilterMetadata: (state, { payload }: PayloadAction<ISalesforceCaseContactFilterMetadata>) => {
            state.contacts = payload.contacts;
            state.defaultContactId = payload.defaultContactId;
        },
        setMachines: (state, { payload }: PayloadAction<string[]>) => {
            state.machines = payload;
        },
    },
});

export const actions = {
    ...salesforceResults.actions,
    ...salesforceMetadata.actions,
};

export default {
    [salesforceResults.name]: salesforceResults,
    [salesforceMetadata.name]: salesforceMetadata,
};
